import { render, staticRenderFns } from "./ElButton.vue?vue&type=template&id=12d3ff21&"
import script from "./ElButton.vue?vue&type=script&lang=ts&"
export * from "./ElButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports